import { Controller } from "@hotwired/stimulus"
import gsap from "gsap"

export default class extends Controller {
  static targets = ["label", "input", "text"]

  connect() {
    // Set initial states
    this.updateStyles()
    if(this.hasTextTarget) {
      this.textTarget.focus()
    }
  }

  inputTargetConnected(input) {
    // Set initial state for newly connected inputs
    this.updateLabelStyle(input)
  }

  // Handle changes on radio buttons and checkboxes
  change(event) {
    if (event.target.type === 'radio') {
      // For radio buttons, we need to reset all and then set the checked one
      this.labelTargets.forEach(label => {
        this.resetLabelStyle(label)
      })

      // Create flash animation
      this.animateRadioSelect(event.target)

      // Auto-submit the form after animation
      const form = this.element
      if (form) {
        // Wait for animation to complete before submitting
        setTimeout(() => {
          form.requestSubmit()
        }, 300) // Matches animation duration
      }
    }

    // Update the style for the changed input's label
    if (event.target.type === 'checkbox') {
      this.updateLabelStyle(event.target)
    }
  }

  // Animate radio button selection
  animateRadioSelect(radioButton) {
    const label = this.labelTargets.find(target => target.contains(radioButton))
    if (!label) return

    // Create a flash effect
    gsap.fromTo(label,
      {
        backgroundColor: "rgba(255, 255, 255, 0.2)",
        scale: 1.02
      },
      {
        backgroundColor: "rgba(28, 42, 45, 1)",
        scale: 1,
        duration: 0.3,
        ease: "power2.out"
      }
    )

    gsap.fromTo(radioButton,
      {
        scale: 1.2
      },
      {
        scale: 1,
        duration: 0.2,
        ease: "back.out(1.5)"
      }
    )
  }

  // Update styles for a single input's label
  updateLabelStyle(input) {
    const label = input.closest('[data-due-diligence-input-target="label"]')
    if (!label) return

    if (input.checked) {
      label.classList.remove('bg-card-background-alternative', 'border-gray-600')
      label.classList.add('bg-gray-600', 'border-gray-500')
    } else {
      this.resetLabelStyle(label)
    }
  }

  // Reset a label to default styles
  resetLabelStyle(label) {
    label.classList.remove('bg-gray-600', 'border-gray-500')
    label.classList.add('bg-card-background-alternative', 'border-gray-600')
  }

  // Update all input labels
  updateStyles() {
    this.inputTargets.forEach(input => {
      this.updateLabelStyle(input)
    })
  }
}
